import { Component, OnDestroy, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageService } from '@irb-common/services/page.service';
import { IrbCreatePortfolioService, IPortfolioExistsActiveResponse } from '@irb/irb-create-portfolio/irb-create-portfolio.service';
import { AppService } from '@irb/app.service';
import {IrbAppEvents, IrbCreatePortfolioEvents } from '@irb-common/events';
import { TooltipService } from '@irb-common/components/tooltip/tooltip.service';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-create-portfolio-dialog',
  templateUrl: './create-portfolio-dialog.component.html',
  styleUrls: ['./create-portfolio-dialog.component.scss', '../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreatePortfolioDialogComponent implements OnDestroy {
  @ViewChild("portfolioNameField") portfolioNameField: any;
  portfolioName: string = "";
  restorePostfolioNames: string = "";
  portfolioNameInUse: boolean = false;
  portfolioIsActive: boolean = false;
  portfolioCanResurrect: boolean = false;
  resurrectOption: string = "Restore";
  continueShow:boolean = false;
  portfolioNameRestore: boolean = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  callToActionText: string;
  callBack: Function;
  isAltWorkflow: boolean;
  canNotContinue: boolean = true;
  tooltipMessage:any="";

  constructor(public dialogRef: MatDialogRef<CreatePortfolioDialogComponent>,
    public ps: PageService,
    public cps: IrbCreatePortfolioService,
    public as: AppService,
    public tts: TooltipService,
    private ats: AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public mdd: any
  ) {
    if(this.mdd) {
      this.portfolioName = this.mdd.portfolioName || "";
      this.callToActionText = this.mdd.callToActionText || "First, name this portfolio. Next, you'll assign accounts to it.";
      this.callBack = this.mdd.callBack;
      this.isAltWorkflow = this.mdd.isAltWorkflow || false;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  close() {
    this.tts.remove();
    this.dialogRef.close();
  }

  checkIfNameExists() {
    this.ats.trackClickEvent("lc_newport_continue");
    this.tooltipMessage="";
    this.portfolioName = this.portfolioNameField.inputControl.value;
    this.restorePostfolioNames = this.portfolioName

    this.cps.checkIfPortfolioExists(this.portfolioNameField.inputControl.value).pipe(takeUntil(this.destroyed$)).subscribe((data: Object) => {
      const r: any = data;
      if (r.responseStatus && r.responseStatus === 'EXCEPTION') {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Server Error',
            detail: "An internal server error occurred",
            sticky:true
        });
        return;
      }
      const d: IPortfolioExistsActiveResponse = data as IPortfolioExistsActiveResponse;
      this.portfolioNameInUse = d.pfExists;
      this.portfolioIsActive = d.isActive;
      this.portfolioCanResurrect = d.allowResurrection;
      if (!d.pfExists) {
        this.callContinueFunction();
      } else {
        if (!d.isActive) {
          if (!d.allowResurrection) {
            this.callContinueFunction();
          } if(d.allowResurrection) {
            this.continueShow = true;
            this.portfolioCanResurrect = true;
            this.portfolioName = '';
            this.portfolioNameRestore = true;
          }
        }
      }
    });
  }

  showAssignAccountsDialog() {
    this.close();
    if(this.resurrectOption === "Restore"){
      this.portfolioName = this.restorePostfolioNames;
    }else{
      this.portfolioName = this.portfolioNameField.inputControl.value;
    }
    this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_ACCOUNT_ASSIGNMENT, {
      portfolioName: this.portfolioName
    });
  }

  toggleNewPortfolioNameFormControl() {
    window.setTimeout(() => {
     if(this.resurrectOption === "Restore"){
      this.portfolioName = '';
      this.continueShow = true;
      this.canNotContinue = false;
      this.portfolioNameRestore = true;
     }else if(this.resurrectOption === "New"){
       this.portfolioNameRestore = false;
       this.continueShow = false;
       this.canNotContinue = true;
     }
    });
  }

  showAssignDialogPortfolio(){
    this.ats.trackClickEvent("lc_newport_continue");

    if(this.resurrectOption === "Restore"){
      this.portfolioCanResurrect = true;
      this.showAssignAccountsDialog();
     }else if(this.resurrectOption === "New"){
       this.canNotContinue = true;
       this.callContinueFunction();
     }
  }

  displayVideo() {
    window.open('/irebal/resources/tutorials/index.jsp?#lesson3p_id20', '_blank');
  }

  callContinueFunction() {
    if (this.callBack) {
      this.callBack(this.portfolioName);
      this.close();
    } else {
      this.showAssignAccountsDialog();
    }
  }

  onInputChange() {
    if(this.portfolioName.length===70)
    {
      this.tooltipMessage="70 characters max";
    }
    else{
      this.tooltipMessage="";
    }
    setTimeout(() => {
      this.canNotContinue = !(this.portfolioNameField?.inputControl?.value?.length > 0 && this.portfolioNameField?.inputControl?.valid);
    });
  }
}
